import React from "react";
import { useApiDocsContext } from "../startup/ApiDocsApp";
import CodeBlock from "./CodeBlock";

const Introduction = () => {
  const { apiDocs } = useApiDocsContext();
  const { authentication, pagination, rate_limiting, asset_urls, error_codes } = apiDocs;

  return (
    <div className="api-docs-introduction">
      <h1 className="api-docs-intro-title">Opendate API Reference</h1>
      <p className="api-docs-intro-description">{apiDocs.description}</p>

      <section className="api-docs-intro-section">
        <h2>Base URL</h2>
        <CodeBlock code={apiDocs.base_url} language="text" />
      </section>

      <section className="api-docs-intro-section">
        <h2>Authentication</h2>
        <p>{authentication.description}</p>
        <p>
          Include the token in the <code>Authorization</code> header:
        </p>
        <CodeBlock
          code={`Authorization: ${authentication.format}`}
          language="text"
        />
        <p>{authentication.token_validity}</p>

        <h3>Authentication Methods</h3>
        <table className="api-docs-param-table">
          <thead>
            <tr>
              <th>Method</th>
              <th>Token URL</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {authentication.methods.map((method) => (
              <tr key={method.name}>
                <td className="api-docs-param-name">{method.name}</td>
                <td><code>{method.token_url}</code></td>
                <td>{method.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="api-docs-intro-section">
        <h2>Pagination</h2>
        <p>{pagination.description}</p>
        <table className="api-docs-param-table">
          <thead>
            <tr>
              <th>Parameter</th>
              <th>Type</th>
              <th>Default</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {pagination.parameters.map((param) => (
              <tr key={param.name}>
                <td className="api-docs-param-name">{param.name}</td>
                <td>{param.type}</td>
                <td>{param.default}</td>
                <td>{param.description}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <h3>Response Format</h3>
        <CodeBlock
          code={JSON.stringify(
            {
              current_page: 1,
              per_page: 30,
              total_entries: 100,
              total_pages: 4,
              collection: ["..."],
            },
            null,
            2
          )}
          language="json"
        />
      </section>

      <section className="api-docs-intro-section">
        <h2>Rate Limiting</h2>
        <p>{rate_limiting}</p>
      </section>

      <section className="api-docs-intro-section">
        <h2>Asset URLs</h2>
        <p>{asset_urls}</p>
      </section>

      <section className="api-docs-intro-section">
        <h2>Error Codes</h2>
        <table className="api-docs-param-table">
          <thead>
            <tr>
              <th>Status Code</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {error_codes.map((code) => (
              <tr key={code.status}>
                <td className="api-docs-param-name">{code.status}</td>
                <td>{code.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default Introduction;
